//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/libs/util'

export default{
	data () {
		return {
			config: {}
		}
	},
	mounted () {
		this.init_config()
	},
	methods: {
		nlbr(val){
			return val.replace(/[\n\r]+/g,'<br>')
		},
		recommend () {
			this.$router.push({path:'/my/recommend_form'})
		},
		recommend_record () {
			this.$router.push({path:'/my/recommend_record'})
		},
		init_config () {
			this.$rest('/sapi/open/global/?name=configs').get()
			.success(data=>{
				this.config = data.recommend_rule
			}).error(response=>{
				this.toast(response.body.message||'','warn')
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/public/recommend.vue